import ApiService from '@/services/CommonApiService.js'

export const namespaced = true
export const state = {
  manufacturers: [],
  selectedManufacturer: ''
}

export const mutations = {
  SET_MANUFACTURERS(state, value) {
    state.manufacturers = value
  },
  SET_SELECTED_MANUFACTURER(state, value) {
    state.selectedManufacturer = value
  }
}

export const actions = {
  fetchManufacturer({ commit }) {
    return ApiService.GetManufactures()
      .then(response => {
        commit('SET_MANUFACTURERS', response.data.data)
        if (
          !this.state.manufacturer.selectedManufacturer &&
          response.data.data.length
        ) {
          commit('SET_SELECTED_MANUFACTURER', response.data.data[0])
        }
      })
      .catch(() => {
        //console.log('IN Catch: ')
      })
  }
}
